<ion-header>
    <ind-header-left [viewData]="indHeaderLeftModel"
                     [hideFilterButton]="true"
                     [searchDisabled]="isDeviceOffline"
                     [searchDebounce]="750"
                     [(searchText)]="query" 
                     (onControlClick)="onPageTitleControlClick($event)"
                     (onSearchInput)="searchAddressGlobally($event)"
                     (onSearchClear)="clearSearch($event)">
    </ind-header-left>
</ion-header>
<ion-content>
    <ng-container *ngIf="!noResult; else noDataTemplate">
        <ion-item-group>
            <ion-item-divider>
                {{ 'SEARCH_RESULTS' | translate }}
            </ion-item-divider>
            <ion-radio-group [(ngModel)]="selectedaddress" (ionChange)="initHeader()">
                <ion-list>
                    <ion-item *ngFor="let address of contactAddress; trackBy: trackById" (click)="selectAddress(address)">
                        <ion-label>{{ address.compositeAdd }}</ion-label>
                        <ion-radio slot="end" [value]="address"></ion-radio>
                    </ion-item>
                </ion-list>
            </ion-radio-group>
        </ion-item-group>
    </ng-container>
    <ng-template #noDataTemplate>
        <ion-item-group>
            <ion-item-divider>
                {{ 'SEARCH_RESULTS' | translate }}
            </ion-item-divider>
            <ion-list>
                <ion-item>
                    <ion-label>{{ 'NO_DATA' | translate }}...</ion-label>
                </ion-item>
            </ion-list>
        </ion-item-group>
    </ng-template>
</ion-content>
<io-spinner [displayText]="'please wait...'" *ngIf="loading"></io-spinner>
